/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHttpPatch = createReactComponent("outline", "http-patch", "IconHttpPatch", [["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-1" }], ["path", { "d": "M10 13h4", "key": "svg-2" }], ["path", { "d": "M17 8h4", "key": "svg-3" }], ["path", { "d": "M19 8v8", "key": "svg-4" }]]);

export { IconHttpPatch as default };
//# sourceMappingURL=IconHttpPatch.mjs.map
